import src from "IMAGE";
export default { src, width: 1663, height: 340, blurWidth: 0, blurHeight: 0};
